import React, { useContext, useState } from 'react';
import Layout from '../Component/layout/main-layout';
import { useTranslation } from 'react-i18next';
import layoutBgImg from '../Images/layout/onlineService.jpg';
import { Post } from '../api/services/api_helpers';
import { Context } from '../Store/context';
import Loading from '../Component/loader/loader'
import GlobalLayout from '../Component/layout/global-layout';

const Calculator = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { showError } = useContext(Context);
  const [inputValue, setInputValue] = useState('');
  const [numChildren, setNumChildren] = useState('');
  const [alimonyAmount, setAlimonyAmount] = useState('');
  const [calculationType, setCalculationType] = useState('');
  const [isWorking, setIsWorking] = useState('');

  const handlePost = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const finalInputValue = isWorking === t('no') ? 1410 : parseFloat(inputValue);
    const data = {
      num_children: parseInt(numChildren, 10),
      amount: finalInputValue,
    };

    try {
      const res = await Post('calculate/', data);
      setAlimonyAmount(res?.alimony_amount || '');
    } catch (error) {
      showError(error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  // Check if both dropdowns are selected
  const isFormValid = calculationType && isWorking;

  return (
    <GlobalLayout
      title={`${t('calculator')} - ${t('supreme_court')} ${t('turkmenistan')}`}
      keywords="Kalkulýator, Onlaýn kalkulýator, Kalkulyator, 
                Onlayn kalkulyator, Aliment hasaplamak"
    >
      <div className="mb-20">
        <Layout
          title={t('calculator')}
          layoutBgImg={layoutBgImg}
        />
        <div
          className="media"
        >
          <div
            className="bg-white dark:bg-dark-box dark:text-dark-text
                      px-6 xl:px-16 py-16 mt-8 pt-6"
          >
            <h1
              className="text-primary dark:text-dark-text 
                        text-xl font-bold mb-6"
            >
              {t('calculator')}
            </h1>
            <form>
              {/* Calculation Type Dropdown */}
              <div className="xl:flex gap-16">
                <div className="xl:w-[50%] flex flex-col">
                  <label htmlFor="calculationType">
                    {t('calculation_type_label')}
                  </label>
                  <select
                    id="calculationType"
                    className="w-full px-2 py-2 border border-border 
                              bg-white rounded mt-1 shadow-inner
                              focus:outline-none focus:ring-2 
                              focus:ring-indigo-500 dark:text-white 
                              dark:bg-dark-box dark:border-dark-border"
                    value={calculationType}
                    onChange={(e) => setCalculationType(e.target.value)}
                  >
                    <option value="" hidden>
                      {t('select')}
                    </option>
                    <option value="Aliment" className="px-4 py-1">
                      Aliment
                    </option>
                  </select>
                </div>

                {/* Is Working Dropdown */}
                <div className="xl:w-[50%] flex flex-col mt-4 xl:mt-0">
                  <label htmlFor="isWorking">
                    {t('is_working')}
                  </label>
                  <select
                    id="isWorking"
                    className="w-full px-2 py-2 border border-border
                             bg-white rounded mt-1 shadow-inner
                             focus:outline-none focus:ring-2 
                             focus:ring-indigo-500 dark:text-white 
                             dark:bg-dark-box dark:border-dark-border"
                    value={isWorking}
                    onChange={(e) => setIsWorking(e.target.value)}
                  >
                    <option value="" hidden>
                      {t('select')}
                    </option>
                    <option value={t('yes')} className="px-4 py-1">
                      {t('yes')}
                    </option>
                    <option value={t('no')} className="px-4 py-1">
                      {t('no')}
                    </option>
                  </select>
                </div>
              </div>

              {/* Show additional inputs only if both dropdowns are selected */}
              {isFormValid && (
                <>
                  <div className="xl:flex gap-16 mt-4 xl:mt-16">
                    <div className="xl:w-[50%] flex flex-col ">
                      <label htmlFor="dynamicInput">
                        {isWorking === t('yes') ? t('payers_salary') : t('average_salary')}
                      </label>
                      <input
                        id="dynamicInput"
                        type="number"
                        value={isWorking === t('no') ? 1410 : inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        className="w-full px-2 py-2 border border-border 
                                bg-white rounded mt-1 shadow-inner
                                focus:outline-none focus:ring-2 
                                focus:ring-indigo-500 dark:text-white 
                                dark:bg-dark-box dark:border-dark-border"
                      />
                    </div>
                    <div className="xl:w-[50%] flex flex-col mt-4 xl:mt-0">
                      <label htmlFor="numChildren">{t('child_number')}</label>
                      <input
                        id="numChildren"
                        type="number"
                        value={numChildren}
                        onChange={(e) => setNumChildren(e.target.value)}
                        className="w-full px-2 py-2 border border-border 
                                bg-white rounded mt-1 shadow-inner
                                focus:outline-none focus:ring-2 
                                focus:ring-indigo-500 dark:text-white 
                                dark:bg-dark-box dark:border-dark-border"
                      />
                    </div>
                  </div>

                  <div className='mt-8 flex flex-col w-full justify-center gap-2
                                 items-center dark:text-dark-text text-center'>
                    {t('paid_alimony')}
                    <div className='flex items-center border border-border
                                   dark:border-dark-border'>
                      <p className="py-2 px-6">
                        {alimonyAmount ? alimonyAmount : '...'}
                      </p>
                      <button
                        type="submit"
                        onClick={handlePost}
                        className={`bg-primary text-white py-2 px-6 
                        ${(!inputValue && inputValue === 1410) ||
                            !numChildren ? 'bg-border' : ''}`}
                        disabled={(!inputValue && inputValue === 1410) ||
                          !numChildren}
                      >
                        {isLoading ? <Loading /> : t('count')}
                      </button>
                    </div>
                    {t('calculated')}
                  </div>
                </>
              )}
            </form>
          </div>
        </div>
      </div>
    </GlobalLayout>
  );
};

export default Calculator;
